import type { ImageProps } from '../Image';

export * from '../Image/types';
export interface HeroImageProps extends ImageProps {}
export type HeroImageDefaultProps = Pick<HeroImageProps, 'resize'>;
